import React from 'react';
import { FaTimes } from 'react-icons/fa';

export default function MonthModal({ isOpen, data, onDataChange, onClose, onSubmit }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-start md:items-center justify-center p-4 bg-black/50 backdrop-blur-sm overflow-y-auto">
            <div className="bg-white rounded-3xl w-full max-w-sm shadow-2xl overflow-hidden animated scaleIn my-auto flex flex-col max-h-[90vh]">
                <div className="p-6 md:p-8 border-b border-gray-100 flex justify-between items-center bg-gray-50/50 shrink-0">
                    <h3 className="text-xl font-bold text-gray-900">
                        {data.id ? 'Edit Month' : 'Add New Month'}
                    </h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-2">
                        <FaTimes size={20} />
                    </button>
                </div>
                <form onSubmit={onSubmit} className="flex flex-col overflow-hidden">
                    <div className="p-6 md:p-8 space-y-6 overflow-y-auto custom-scrollbar">
                        <div>
                            <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Month Name</label>
                            <select
                                value={data.name}
                                onChange={(e) => onDataChange({ ...data, name: e.target.value })}
                                className="w-full border rounded-xl p-3 bg-gray-50 focus:ring-2 focus:ring-blue-500 outline-none font-medium appearance-none cursor-pointer"
                                required
                            >
                                <option value="">Select Month</option>
                                {[
                                    'January', 'February', 'March', 'April', 'May', 'June',
                                    'July', 'August', 'September', 'October', 'November', 'December'
                                ].map(month => (
                                    <option key={month} value={month}>{month}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Display Order</label>
                            <input
                                type="number"
                                value={data.sort_order}
                                onChange={(e) => onDataChange({ ...data, sort_order: e.target.value })}
                                className="w-full border rounded-xl p-3 bg-gray-50 focus:ring-2 focus:ring-blue-500 outline-none font-medium"
                                placeholder="1"
                                required
                            />
                        </div>
                    </div>
                    <div className="p-6 md:p-8 border-t border-gray-50 flex justify-end gap-3 shrink-0">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-6 py-3 font-bold text-gray-400 hover:text-gray-600"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-8 py-3 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 shadow-xl shadow-blue-100"
                        >
                            {data.id ? 'Save Changes' : 'Create Month'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
